import { FC, useMemo } from 'react';
import { Form, Tabs } from 'antd';
import { ActionEntityType, UserRoleType } from '@pmp/api';
import { useTranslation } from 'react-i18next';
import { CrudMode } from '@ohpen/enso-ui';

import { FormSchemaProps } from '../interfaces';
import { BrokerDetailsTab, NotesTab, AssistantsTab, AdvisersTab } from '.';

export const BrokersFormSchema: FC<FormSchemaProps> = ({ form, mode, selectsOptions, onTabChange, defaultComplianceStatus, setDisableSave }) => {
  const { t } = useTranslation();
  const entityType = ActionEntityType.BROKERS;

  const watchedRoles = Form.useWatch('roles') as UserRoleType[] | undefined;
  const isAdvisor = watchedRoles?.includes(UserRoleType.ADVISOR) ?? false;
  const isAssistant = watchedRoles?.includes(UserRoleType.ASSISTANT) ?? false;

  const items = useMemo(
    () => [
      {
        key: 'broker-details',
        label: t('lender.brokers.labels.brokerDetails'),
        children: <BrokerDetailsTab form={form} mode={mode} selectsOptions={selectsOptions} defaultComplianceStatus={defaultComplianceStatus} />,
      },
      ...(isAdvisor
        ? [{
          key: 'assistants',
          label: t('lender.brokers.labels.assistants'),
          children: <AssistantsTab form={form} mode={mode} selectsOptions={selectsOptions} setDisableSave={setDisableSave} />,
        }]
        : []),
      ...(isAssistant
        ? [{
          key: 'advisers',
          label: t('lender.brokers.labels.advisers'),
          children: <AdvisersTab form={form} mode={mode} selectsOptions={selectsOptions} setDisableSave={setDisableSave} />,
        }]
        : []),
      ...(CrudMode.CREATE === mode
        ? []
        : [{
          key: 'notes',
          label: t('lender.brokers.labels.notes'),
          children: <NotesTab form={form} mode={mode} selectsOptions={selectsOptions} entityType={entityType} />,
        }]),
    ],
    [form, mode, selectsOptions, t, entityType, isAdvisor, isAssistant, defaultComplianceStatus, setDisableSave],
  );

  return (
    <div className="enso-ui-tabs-wrapper">
      <Tabs items={items} onChange={onTabChange} />
    </div>
  );
};
